import { trace } from '../log';
import Loadable from 'react-loadable';

const Loading = ({ isLoading, pastDelay, error }) => {
  if (isLoading && pastDelay) {
    trace('isloading and pastDelay');
    return <p>Loading...</p>;
  } else if (error && !isLoading) {
    error(error);
    return <p>Error!</p>;
  } else {
    trace('not loading and no error');
    return null;
  }
};

const LoadableTestBanner = Loadable({
  loader: () => import(
    /* webpackChunkName: 'TestBanner' */
    './test-banner/index.jsx'
  ),
  loading: Loading
});

const TrackedTestBanner = Loadable({
  loader: () => import(
    /* webpackChunkName: 'TrackedTestBanner' */
    './tracked-test-banner.js'
  ),
  loading: Loading
});

const LoadableTesTopAd = Loadable({
  loader: () => import(
    /* webpackChunkName: 'TesTopAd' */
    './tes-top-ad/index.jsx'
  ),
  loading: Loading
});

export const componentMap = {
  TestBanner: LoadableTestBanner,
  TesTopAd: LoadableTesTopAd,
  TrackedTestBanner
};
